// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/inter';
import './index.css'; // Include global styles
import { hasFirebaseFrontendConfig, isMaintenancePageEnabled, missingFirebaseConfig } from './config/frontendEnv';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);

async function boot() {
  if (isMaintenancePageEnabled) {
    const { default: MaintenancePage } = await import('./pages/MaintenancePage');
    root.render(
      <React.StrictMode>
        <MaintenancePage />
      </React.StrictMode>
    );
    return;
  }

  if (!hasFirebaseFrontendConfig) {
    console.error('Missing Firebase frontend config:', missingFirebaseConfig);
    return;
  }

  const { default: App } = await import('./App');

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

boot().catch((error) => {
  console.error('Spurlex failed to boot', error);
});
